
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(146|574|670|941)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
